import { render } from "./ChatFooter.vue?vue&type=template&id=bdb5ea12&scoped=true"
import script from "./ChatFooter.vue?vue&type=script&lang=js"
export * from "./ChatFooter.vue?vue&type=script&lang=js"

import "./ChatFooter.vue?vue&type=style&index=0&id=bdb5ea12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb5ea12"]])

export default __exports__